import { isFeatureActive } from '@helpers';
import { BEMBlock } from 'helpers/classnames';
import { useConfig } from '@common/Hooks/useConfig';
import { useHasMounted } from '@common/Hooks/useHasMounted';
import { useTranslation } from '@common/Hooks/useTranslation';
import { formatLanguageOptions } from '@helpers/formatLanguageOptions';
import { FooterNavigationIcons } from '../components/FooterNavigationIcons';
import { FooterNavigationLinks } from '../components/FooterNavigationLinks';
import { FooterNavigationSocial } from '../components/FooterNavigationSocial';

import '../styles/FooterBody.scss';

export function FooterBody({
    socialLinks,
    appLinks,
    navigations,
    paymentMethodsIcons,
    paymentMethodsNavUrl,
    deliveryOptionsIcons,
    deliveryOptionsNavUrl,
    languages
}) {
    const hasMounted = useHasMounted();
    const translate = useTranslation();
    const config = useConfig();
    const isLanguageSelectActive = isFeatureActive('PLT-26652-add-lang-select-desktop', config);
    const langOptions = formatLanguageOptions(languages ? languages[config.store] : false);
    const [block, BEMElement] = BEMBlock('react-footer-body');

    return (
        <div className={block}>
            <div className={BEMElement('content')}>
                {
                    navigations.map(navigation => (
                        <FooterNavigationLinks
                            key={navigation.name}
                            customClass={BEMElement('navigation-column')}
                            navigation={navigation}
                        />
                    ))
                }
                <FooterNavigationSocial
                    appLinks={appLinks}
                    customClass={BEMElement('social-column')}
                    socialLinks={socialLinks}
                />
                <FooterNavigationIcons
                    customClass={BEMElement('icons-column')}
                    disclaimer={translate('checkout.information.binding_sale')}
                    icons={paymentMethodsIcons}
                    link={paymentMethodsNavUrl}
                    title={translate('footer.payment_options.label')}
                />
                <FooterNavigationIcons
                    customClass={BEMElement('icons-column')}
                    icons={deliveryOptionsIcons}
                    link={deliveryOptionsNavUrl}
                    title={translate('footer.delivery_options.label')}
                />
                {
                    hasMounted // render languages on mount to be able to cache SSR requests, because url is dynamic
                    && isLanguageSelectActive
                    && langOptions.children.length > 1
                    && (
                        <FooterNavigationLinks
                            key={langOptions.name}
                            customClass={BEMElement('navigation-column')}
                            navigation={langOptions}
                        />
                    )
                }
            </div>
        </div>

    );
}
